module.exports = __webpack_public_path__ + "fonts/Antenna-Regular.73ce6c62.ttf";